import { MediaType, tvpil } from '../../../data/compat/tvpil';
import { KalturaTopShelfAsset } from '../../composed';
import { createAssetMetaOrTagGroupBy, createChannelFilter, createPager } from '../../factories';
import { processTopShelfAsset } from '../../processing/topShelf/processing';
import { fetchAssetList } from '../../services';
import { getResponseProfile } from '../collection';

const retrievedProperties = [
  'description',
  'enableCatchUp',
  'endDate',
  'error',
  'id',
  'images',
  'linearAssetId',
  'mediaFiles',
  'metas.Adult',
  'metas.ContentMarkerText',
  'metas.Deeplink',
  'metas.DeeplinkURN',
  'metas.duration',
  'metas.EpisodeName',
  'metas.EpisodeNumber',
  'metas.Is_Deeplink',
  'metas.MarkerBackgroundColor',
  'metas.MarkerTextColor',
  'metas.SeasonNumber',
  'metas.SeriesID',
  'metas.Year',
  'name',
  'startDate',
  'tags.AudioLanguage',
  'tags.audioType',
  'tags.BillingId',
  'tags.Country',
  'tags.CountryOfOrigin',
  'tags.display_type',
  'tags.Genre',
  'tags.ParentalRating',
  'tags.Quality',
  'tags.SeriesName',
  'type',
].join();

type FetchTopShelf = {
  collectionId: number;
  groupBy?: string;
  kSql?: string;
  pageIndex: number;
  pageSize: number;
};

const mediaTypes = [MediaType.Episode, MediaType.Movie, MediaType.Package, MediaType.Series];

function createTopShelfAssetTypesKsql() {
  return `(or asset_type='epg' ${mediaTypes.map((type) => `asset_type='${tvpil.dms.mediaTypes[type]}'`).join(' ')})`;
}

function createTopShelfKsql(kSql = '') {
  const typesKSql = `(and ${createTopShelfAssetTypesKsql()} start_date>'-${tvpil.dms.playableCatchupBuffer}')`;

  return `(and ${kSql} ${typesKSql})`;
}

export async function fetchTopShelf({ collectionId, groupBy, kSql, pageIndex, pageSize }: FetchTopShelf) {
  const assetGroupBy = groupBy ? [createAssetMetaOrTagGroupBy({ value: groupBy })] : undefined;
  const responseProfile = getResponseProfile({
    availableRatings: tvpil.availableRatingsNames,
    availableProviders: tvpil.availableProviders,
    groupBy,
    retrievedProperties,
  });
  const resKSql = createTopShelfKsql(kSql);

  const { objects, totalCount } = await fetchAssetList<KalturaTopShelfAsset>({
    filter: createChannelFilter({
      idEqual: collectionId,
      groupBy: assetGroupBy,
      kSql: resKSql,
    }),
    pager: createPager({
      pageIndex,
      pageSize,
    }),
    responseProfile,
  });

  return {
    objects: objects.map(processTopShelfAsset),
    totalCount,
  };
}
